<div class="d-flex align-items-center">
  <span class="txt">{{deparureCity}}</span>
  <img width="20px" height="17px" style="margin: 0 7px;" src="assets/images/arrow_leg.svg" alt="arrowRight">
  <span class="txt">{{arrivalCity}}</span>
</div>
